// Revieve partner ids per shop. This map is also the country gate - shops that
// are missing here never render the Hair Analyzer.
// Keep in sync with notino/hair-analyzer-fragment src/countryConfig.ts
export const haCountryConfig = {
  'notino.cz': {
    locale: 'cz',
    partnerId: 'RLXTTvJs3z',
  },
  'notino.sk': {
    locale: 'sk',
    partnerId: 'kEINyZMIfM',
  },
  'notino.pl': {
    locale: 'pl',
    partnerId: 'MVDfg1dote',
  },
  'notino.it': {
    locale: 'it',
    partnerId: 'ApGsWgpEPG',
  },
  'notino.hu': {
    locale: 'hu',
    partnerId: 'apsGdMi0PX',
  },
  'notino.ro': {
    locale: 'ro',
    partnerId: 'FHDhDURi9L',
  },
};
